export default "__VITE_ASSET__DmMp3nu1__"